import React, { createContext, useContext, useMemo, useState } from 'react';

type TContextState = {
  customPreviewData: string;
};
type TContext = {
  setValue: (c: TContextState) => void;
  value: TContextState;
};
const Context = createContext<TContext | null>(null);

type Props = {
  children: JsxNode;
};
export function FormContextProvider({ children }: Props) {
  const [value, setValue] = useState<TContextState>({
    customPreviewData: '{}',
  });
  const context = useMemo(() => ({ value, setValue }), [value, setValue]);

  return <Context.Provider value={context}>{children}</Context.Provider>;
}

export function useCustomPreviewData() {
  const context = useContext(Context);
  if (!context) {
    throw new Error('useCustomPreviewData must be used within a FormContextProvider');
  }
  const { value, setValue } = context;
  return useMemo(() => {
    return [
      value.customPreviewData,
      (v: string) => {
        setValue({ ...value, customPreviewData: v });
      },
    ] as const;
  }, [value, setValue]);
}
